import React, { useState } from "react";
import "./info-button.styles.scss";

const InfoButton = (props) => {
    const [isOnHover, setIsOnHover] = useState(false);
    const handleOnMouseEnter = () => {
        setIsOnHover(true)
    };

    const handleOnMouseLeave = () => {
        setIsOnHover(false)
    };

    const handleKeyDown = (e) => {
        if (e.code === 'Enter' || e.code === 'Space' || e.code === 'NumpadEnter') {
            setIsOnHover(!isOnHover);
        }
    };

    return (
        <>
            <div className="info-button__container" tabIndex={0} onMouseEnter={handleOnMouseEnter} onMouseLeave={handleOnMouseLeave} onKeyDown={handleKeyDown}>
                <span className="info-button__icon">?</span>
            </div>
            <div className={`info-modal-container ${isOnHover ? "info-modal-container--visible" : "info-modal-container--hidden"}`}>
                <p className="info-modal-text">{props.infoText}</p>
            </div>
        </>
    );
};

export default InfoButton;